<script setup>
import BaseDialog from "@/base-components/Dialog/BaseDialog.vue";
import Button from "@/base-components/Button";
import {uri} from "@/constants/config";
import InputText from "@/base-components/Form/InputText.vue";
import {Form} from "vee-validate";
import {FormLabel} from "@/base-components/Form";
import BaseInputSelect from "@/base-components/Form/BaseInputSelect.vue";
import {onMounted, ref} from "vue";
import {object} from "yup";
import {useFetch} from "@/composables/useFetch";
import useValidate from "@/composables/useValidate.js";
import {useI18n} from "vue-i18n";
import InputTextarea from "@/base-components/Form/InputTextarea.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  wallet: {
    required: true,
  }
})
const {t: $t} = useI18n()
const isLoadingFlag = ref(false)
const emit = defineEmits(['close', 'onSuccess']);
const validationSchema = object(useValidate(['amount', 'comment']),);

function close() {
  emit('close')
}

const requestParams = ref({
  amount: props.wallet.amount,
  id: props.wallet.User.id,
})
async function updateWallet() {
  isLoadingFlag.value = true
  requestParams.value.amount = parseInt(requestParams.value.amount)
  try {
   const{data} =  await useFetch(`${uri.admin.financial.wallet.update}/${props.wallet.User.id}`, {
      method: "PATCH",
      body: requestParams.value
    });
   if(data){
     emit("onSuccess")
   }
  } catch (err) {
    console.log(err)
  } finally {
    isLoadingFlag.value = false
  }
}

</script>

<template>
  <section>
    <BaseDialog
        :size="'lg'"
        staticBackdrop
        :open="show"
        :has-footer="true"
        :title="$t('title.update')"
        @close="close"
    >
      <div class="rounded-md px-2 py-2 w-full max-h-[78vh] overflow-auto mb-5">
        <Form id="myForm" :validationSchema="validationSchema" @submit="updateWallet">
          <div class="grid grid-cols-1 gap-3">
            <div class="col-span-2 md:col-span-1 lg:col-span-1 xl:col-span-1">
              <FreeStyleShimmer height="38px" width="100%" class="mt-10"
                                v-if="isLoadingFlag"/>
              <InputText
                  v-else
                  name="amount"
                  :has-label="true"
                  :label="$t('label.amount')"
                  v-model="requestParams.amount"
                  id="input-wizard-3"
                  type="number"
                  dir="ltr"
              />
            </div>
          </div>
        </Form>
      </div>

      <template v-slot:footer>
        <div class="flex col-md-12 items-end justify-end gap-2">
          <Button variant="outline-secondary" @click="close" size="sm" class=" shadow-md justify-end items-end">
            {{ $t('button.cancel') }}
          </Button>
          <Button variant="primary" size="sm" form="myForm" class=" shadow-md justify-end items-end">
            {{ $t('button.update') }}
          </Button>
        </div>
      </template>

    </BaseDialog>
  </section>
</template>

<style scoped>

</style>